import React from "react";
import { useNavigate } from "react-router-dom";
// import { Link } from "react-router-dom";

const services = [
  {
    id: 1,
    title: "Structural Design",
    desc: "Safe and economical structural solutions for residential and commercial buildings.",
    image: "/service/Structural-Design.jpg",
  },
  {
    id: 2,
    title: "Structural Analysis",
    desc: "Design and detailing of steel structures with fabrication drawings.",
    image: "/service/service22.png",
  },
  {
    id: 3,
    title: "Construction Drawings & Documentation",
    desc: "Advanced analysis and design of tall buildings considering wind & seismic loads.",
    image: "/service/service3.jpg",
  },
  {
    id: 4,
    title: "Structural Assessment & Inspection",
    desc: "Detailed project reports for approvals, planning, and execution.",
    image: "/images/About image.jpg",
  },
  {
    id: 5,
    title: "Structural Rehabilitation & Retrofitting",
    desc: "Detailed project reports for approvals, planning, and execution.",
    image: "/service/service5.webp",
  },
  {
    id: 6,
    title: "Foundation Engineering",
    desc: "Detailed project reports for approvals, planning, and execution.",
    image: "/project/foundation-engineering.jpg",
  },

  {
    id: 7,
    title: "Seismic & Wind Engineering",
    desc: "Detailed project reports for approvals, planning, and execution.",
    image: "/project/Seismic-&-Wind Engineering.jpg",
  },

  {
    id: 8,
    title: "Construction Support Services",
    desc: "Detailed project reports for approvals, planning, and execution.",
    image: "/project/Construction_Support_Services.webp",
  },

  {
    id: 9,
    title: "Temporary Structures",
    desc: "Detailed project reports for approvals, planning, and execution.",
    image: "/project/temporary-tent-structures.webp",
  },
  {
    id: 10,
    title: "Compliance & Certification",
    desc: "Detailed project reports for approvals, planning, and execution.",
    image: "/project/Compliance-Training.jpg",
  },
  {
    id: 11,
    title: "Specialized Services",
    desc: "Detailed project reports for approvals, planning, and execution.",
    image: "/project/Specialized-Services.png",
  },

];

const ServicesSection = () => {

  return (
    <>
      <div className="text-center mb-10 mt-4">
        <h2 className="text-4xl md:text-5xl font-bold text-[#011321] mb-4"> Our Services</h2>
        {/* <div className="w-20 h-[2px] bg-gray-300 mx-auto mb-4 mt-6"></div> */}
        <span className="block w-24 sm:w-32 md:w-40 h-0.5 sm:h-1 mx-auto lg:mx-auto bg-gradient-to-r from-yellow-500 via-yellow-300 to-white rounded-full mt-4 sm:mt-6 mb-4"></span>
        <p className="text-lg text-gray-600 max-w-2xl mx-auto leading-relaxed">
          Strength, quality and trust in every structure we design and deliver.
        </p>
      </div>

      <section
        className="relative py-32 bg-fixed bg-center bg-fill"
        style={{
          backgroundImage: "url('/aaj-home/carousal-build2.jpg')",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover"
        }}

      >

        {/* Overlay */}
        <div className="absolute inset-0 bg-[#0b1a2d]/50"></div>

        {/* Content */}
        <div className="relative z-10 max-w-7xl mx-auto px-6 text-center">

          {/* Cards */}
          <div className="flex flex-wrap justify-center gap-x-16 gap-y-16">
            {services.map((service) => (
              <DiamondCard key={service.id} service={service} />
            ))}
          </div>

        </div>

      </section>
    </>
  );
};

export default ServicesSection;

/* ------------------ Diamond Card ------------------ */

const DiamondCard = ({ service }) => {
  const navigate = useNavigate();
  return (
    <div className="flex justify-center">
      <div className="group relative w-[300px] h-[340px] rounded-2xl overflow-hidden shadow-xl bg-white border-4 border-[#00B9F1]">

        {/* BACK LAYER (appears on hover) */}
        <div className="
          absolute inset-0 
          bg-gradient-to-br from-[#011321] to-[#055a8b]
          flex flex-col items-center justify-center text-center p-5
          text-white
        ">

          <h3 className="text-2xl font-semibold mb-3 tracking-wide">
            {service.title}
          </h3>

          {/* <p className="text-sm opacity-90 mb-5">
            High quality engineering solutions designed with precision and innovation.
          </p> */}

          <button
            onClick={() => navigate(`/services/${service.id}`)}
            className=" read-more-btn  px-6 py-2 mt-8 bg-white text-[#011321] font-semibold rounded-full 
            shadow-lg transition-all duration-300
            hover:scale-110 hover:bg-gray-200 cursor-pointer"
          >
            Read More →
          </button>


        </div>

        {/* FRONT IMAGE CARD (slides down instead of up) */}
        <div
          className="
          absolute inset-0 
          transition-transform duration-1000 ease-in-out
          group-hover:translate-y-[100%]
        "
        >
          <img
            src={service.image}
            alt={service.title}
            className="w-full h-full object-fill"
          />



          {/* GLASS TITLE STRIP */}
          <div className="
            absolute bottom-0 left-0 right-0
            bg-black/60 backdrop-blur-md text-white text-center py-3
          ">
            <h3 className="text-lg font-semibold tracking-wide">
              {service.title}
            </h3>
          </div>
        </div>

        {/* Soft glow border on hover */}
        <div className="
          absolute inset-0 rounded-2xl border-2 border-transparent
          group-hover:border-[#00B9F1]
          transition-all duration-300
        "></div>

      </div>
    </div>
  );
};




